const VIEWER_KEY_STORAGE_KEY = 'liveblocks-viewer-key';
const VIEWER_KEY_FORMAT = /^[a-f0-9]{64}$/;

export const getLiveblocksViewerKey = (): string | undefined => {
  try {
    const viewerKey = window.localStorage.getItem(VIEWER_KEY_STORAGE_KEY);
    return viewerKey && VIEWER_KEY_FORMAT.test(viewerKey) ? viewerKey : undefined;
  } catch {
    return undefined;
  }
};

export const saveLiveblocksViewerKey = (viewerKey: string): void => {
  try {
    window.localStorage.setItem(VIEWER_KEY_STORAGE_KEY, viewerKey);
  } catch {
    return;
  }
};
